<form [formGroup]="emailForm" (ngSubmit)="goToPassword()">
  <citadel-form-section>
    <div class="header-strip mx-32 mt-32 mb-16">
      <div class="formHeader">Enter your email address</div>
    </div>

    <citadel-form-element heading="Username" class="mx-32" optional>
       <citadel-input [formControlName]="'email'" name="SCPSignInEmail" *citadelValidate="emailForm.controls['email']"
      (input)="updateIdentification($event, 'email')" placeholder="Enter email" autocomplete="username" /> 



    </citadel-form-element>
    @if (emailFormSubmitted && usernameForm.email.invalid && usernameForm.email.errors.required) {
      <div
        class="invalid-feedback mx-32">
        <small>Email is required</small>
      </div>
    }


    <div class="mx-32 mt-24 mb-32">
      <citadel-button [isSubmit]="true" buttonStyle="primary" (click)="goToPassword()" [heading]="'Next: Password'"
      [icon]="{right:'chevron-right'}" buttonSize="large" />
    </div>
    <div class="mx-32 mb-32">
      <span> Don't have a profile?</span>
      <a [routerLink]="['/register']" class="teal">&nbsp;Register here</a>
    </div>

  </citadel-form-section>
</form>
